import { Events, TEventBusEventsMap } from './types';
import { navigateToUrl } from 'single-spa';
import { createNanoEvents, Emitter } from 'nanoevents';
import { applyTheme } from '../theme';
import { sidebarStore, tokenStore, userStore } from '../../store';

const eventBus: Emitter<TEventBusEventsMap> = createNanoEvents();

const { setToken, clearToken } = tokenStore();
const { setUser, clearUser } = userStore();

export const initEventBus = () => {
  eventBus.on(Events.THEME_CHANGE, ({ data }) => {
    applyTheme(data);
  });

  eventBus.on(Events.USER_LOGIN, ({ data: { loginData, userData } }) => {
    if (userData) {
      setUser(userData);
    }

    if (loginData) {
      setToken(loginData);
    }

    location.reload();
  });

  eventBus.on(Events.USER_LOGOUT, ({ onSuccess }) => {
    clearUser();
    clearToken();

    if (onSuccess) {
      if (!onSuccess()) {
        return; // do not reload if onSuccess returns false
      }
    }

    location.reload();
  });

  eventBus.on(
    Events.USER_UPDATE_SESSION,
    ({ data: { loginResponse, goto } }) => {
      clearUser();
      setToken(loginResponse);

      if (!goto) {
        location.reload();
      } else {
        navigateToUrl(`${location.origin}${goto}`);
      }
    }
  );

  eventBus.on(Events.NAVIGATE, ({ data }) => {
    navigateToUrl(`${location.origin}${data}`);
  });

  eventBus.on(Events.SIDEBAR_TOGGLE, ({ data }) => {
    sidebarStore.isOpen.value = data;
  });

  return eventBus;
};
